var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('apexchart',{attrs:{"type":"bar","height":_vm.height,"options":_vm.series.chartOptions,"series":_vm.series.series}}),(_vm.series.loading)?_c('v-icon',{staticStyle:{"top":"-40%","left":"50%","z-index":"999","position":"relative"}},[_vm._v(" mdi-autorenew mdi-spin ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }